import brandLogo from './Images/ndalogo.jpg';

export const BRAND_NAME = 'Nutrition And Dietetics Academy admin platform';
export const BRAND_SHORT_NAME = 'NDA Admin';
export const ORGANIZATION_NAME = 'Nutrition And Dietetics Academy';
export const BRAND_LOGO_PUBLIC_URL = 'https://live.ubunifucollege.com/ndalogo.jpg';
export const BRAND_LOGO_ALT = `${ORGANIZATION_NAME} logo`;
export const AUTH_BADGE_LABEL = 'Admin Portal';
export const AUTH_HEADING = BRAND_NAME;

export { brandLogo };
